import { getCurrentTimestamp } from "../Constants.js";

export default class Arubastini {

  static getCard = (index) => {
    let card = null;

    this.cards.forEach(item => {
      if(item.index === index) {
        card = {...item};
        return;
      }
    })

    return card;
  }

  static cards = [
    {
      character: "3",
      symbol: "kopa",
      value: 0,
      index: 1,
    },
    {
      character: "4",
      symbol: "kopa",
      value: 0,
      index: 2,
    },
    {
      character: "5",
      symbol: "kopa",
      value: 0,
      index: 3,
    },
    {
      character: "6",
      symbol: "kopa",
      value: 0,
      index: 4,
    },
    {
      character: "7",
      symbol: "kopa",
      value: 10,
      index: 5,
    },
    {
      character: "A",
      symbol: "kopa",
      value: 11,
      index: 6,
    },
    {
      character: "J",
      symbol: "kopa",
      value: 3,
      index: 7,
    },
    {
      character: "Q",
      symbol: "kopa",
      value: 2,
      index: 8,
    },
    {
      character: "K",
      symbol: "kopa",
      value: 4,
      index: 9,
    },
    {
      character: "3",
      symbol: "jembe",
      value: 0,
      index: 10,
    },
    {
      character: "4",
      symbol: "jembe",
      value: 0,
      index: 11,
    },
    {
      character: "5",
      symbol: "jembe",
      value: 0,
      index: 12,
    },
    {
      character: "6",
      symbol: "jembe",
      value: 0,
      index: 13,
    },
    {
      character: "7",
      symbol: "jembe",
      value: 10,
      index: 14,
    },
    {
      character: "A",
      symbol: "jembe",
      value: 11,
      index: 15,
    },
    {
      character: "J",
      symbol: "jembe",
      value: 3,
      index: 16,
    },
    {
      character: "Q",
      symbol: "jembe",
      value: 2,
      index: 17,
    },
    {
      character: "K",
      symbol: "jembe",
      value: 4,
      index: 18,
    },
    {
      character: "3",
      symbol: "kisu",
      value: 0,
      index: 19,
    },
    {
      character: "4",
      symbol: "kisu",
      value: 0,
      index: 20,
    },
    {
      character: "5",
      symbol: "kisu",
      value: 0,
      index: 21,
    },
    {
      character: "6",
      symbol: "kisu",
      value: 0,
      index: 22,
    },
    {
      character: "7",
      symbol: "kisu",
      value: 10,
      index: 23,
    },
    {
      character: "A",
      symbol: "kisu",
      value: 11,
      index: 24,
    },
    {
      character: "J",
      symbol: "kisu",
      value: 3,
      index: 25,
    },
    {
      character: "Q",
      symbol: "kisu",
      value: 2,
      index: 26,
    },
    {
      character: "K",
      symbol: "kisu",
      value: 4,
      index: 27,
    },
    {
      character: "3",
      symbol: "karanga",
      value: 0,
      index: 28,
    },
    {
      character: "4",
      symbol: "karanga",
      value: 0,
      index: 29,
    },
    {
      character: "5",
      symbol: "karanga",
      value: 0,
      index: 30,
    },
    {
      character: "6",
      symbol: "karanga",
      value: 0,
      index: 31,
    },
    {
      character: "7",
      symbol: "karanga",
      value: 10,
      index: 32,
    },
    {
      character: "A",
      symbol: "karanga",
      value: 11,
      index: 33,
    },
    {
      character: "J",
      symbol: "karanga",
      value: 3,
      index: 34,
    },
    {
      character: "Q",
      symbol: "karanga",
      value: 2,
      index: 35,
    },
    {
      character: "K",
      symbol: "karanga",
      value: 4,
      index: 36,
    },
  ]

  static shufflesCards = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]]; // Swap elements
    }
  }

  static processMove = (params) => {
    return new Promise( async (resolve, reject) => {
      let {
        selectedCard, 
        database,
        gameData,
      } = params;

      //in arubastini there are only 2 important moves, the first and the second
      const playedCards = JSON.parse(gameData.boardData).playedCards;
      const playedCardsObjects = playedCards.map((item, i) => {
        return this.getCard(item);
      })
      const mchezo = this.getCard(JSON.parse(gameData.boardData).mchezo);

      if(playedCards.length === 0) {
        //this is the first move

        //add card to playedCards
        playedCards.push(selectedCard);

        //change current player
        let currentPlayer = null;
        if(gameData.currentPlayer === gameData.playerId) {
          currentPlayer = gameData.opponentId;
        } else if(gameData.currentPlayer === gameData.opponentId) {
          currentPlayer = gameData.playerId;
        }

        //reset timer
        const sessionTimer = (process.env.PLAYER_SESSION_DURATION_IN_MIN * 60) + getCurrentTimestamp();
        
        //remove card from user
        const playerData = JSON.parse(gameData.playerData);
        const opponentData = JSON.parse(gameData.opponentData);
                  
        if(gameData.currentPlayer === gameData.playerId) {
          const availableCards = playerData.availableCards.filter((card) => {
            return (card !== selectedCard);
          })
          playerData.availableCards = availableCards;
        } else if(gameData.currentPlayer === gameData.opponentId) {
          const availableCards = opponentData.availableCards.filter((card) => {
            return (card !== selectedCard);
          })
          opponentData.availableCards = availableCards;
        }

        if(currentPlayer) {
          //update database
          //handle playedCards show
          const playedCardsShow = JSON.parse(gameData.boardData).playedCardsShow;
          playedCardsShow.push(selectedCard);
          const boardData = {
            ...JSON.parse(gameData.boardData),
            playedCards,
            playedCardsShow,
          }

          await database.execute(
            "UPDATE games SET boardData = ?, currentPlayer = ?, sessionTimer = ?, playerData = ?, opponentData = ? WHERE id = ?",
            [JSON.stringify(boardData), currentPlayer, sessionTimer, JSON.stringify(playerData), JSON.stringify(opponentData),  gameData.id]
          ).then(() => {
            resolve(true);
          }).catch((error) => {
            reject("Server error #1018");
          }) 
        } else {
          reject("Unkown server error #101");
        }

      } else if(playedCards.length === 1) {
        // this is second move
        //get topcard 
        const topCard = selectedCard;
        const bottomCard = playedCards[(playedCards.length - 1)];

        const topCardObject = this.getCard(topCard);
        const bottomCardObject = this.getCard(bottomCard);

        //process move here and manipulate data
        const playerData = JSON.parse(gameData.playerData);
        const opponentData = JSON.parse(gameData.opponentData);
        
        //first check if they are of the same symbols
        const totalCardsValue = topCardObject.value + bottomCardObject.value;
        let playerScore = playerData.score;
        let opponentScore = opponentData.score;
        let currentPlayer = null;

        if(topCardObject.symbol === bottomCardObject.symbol) {
          //use values
          if(topCardObject.value > bottomCardObject.value) {

            //topcard owner (currentPlayer) wins the point
            if(gameData.currentPlayer === gameData.playerId) {
              //current player is playerData
              playerData.score = playerScore + totalCardsValue;
              currentPlayer = gameData.playerId;
            } else if(gameData.currentPlayer === gameData.opponentId) {
              //current player is opponentData
              opponentData.score = opponentScore + totalCardsValue;
              currentPlayer = gameData.opponentId;
            }

          } else if(bottomCardObject.value > topCardObject.value) {

            //bottom card owner (non currentPlayer) wins the points
            if(gameData.currentPlayer === gameData.playerId) {
              //current player is playerData, so we flip and use opponentData
              opponentData.score = opponentScore + totalCardsValue;
              currentPlayer = gameData.opponentId;
            } else if(gameData.currentPlayer === gameData.opponentId) {
              //current player is opponentData, so we flip and use playerData
              playerData.score = playerScore + totalCardsValue;
              currentPlayer = gameData.playerId;
            }

          } else {
            //they are of equal values probably 0, no one wins the points.
            //currentPlayer mantains turf
            currentPlayer = gameData.currentPlayer;
          }
        } else {
          //now symbols are different, check if any is mchezo, one with mchezo wins
          if(topCardObject.symbol === mchezo.symbol) {

            //topcard owner wins
            //topcard owner (currentPlayer) wins the point
            if(gameData.currentPlayer === gameData.playerId) {
              //current player is playerData
              playerData.score = playerScore + totalCardsValue;
              currentPlayer = gameData.playerId;
            } else if(gameData.currentPlayer === gameData.opponentId) {
              //current player is opponentData
              opponentData.score = opponentScore + totalCardsValue;
              currentPlayer = gameData.opponentId;
            }

          } else if(bottomCardObject.symbol === mchezo.symbol) {

            //bottom card wins
            //bottom card owner (non currentPlayer) wins the points
            if(gameData.currentPlayer === gameData.playerId) {
              //current player is playerData, so we flip and use opponentData
              opponentData.score = opponentScore + totalCardsValue;
              currentPlayer = gameData.opponentId;
            } else if(gameData.currentPlayer === gameData.opponentId) {
              //current player is opponentData, so we flip and use playerData
              playerData.score = playerScore + totalCardsValue;
              currentPlayer = gameData.playerId;
            }

          } else {
            //if no mchezo, bottomcard wins
            //bottom card owner (non currentPlayer) wins the points
            if(gameData.currentPlayer === gameData.playerId) {
              //current player is playerData, so we flip and use opponentData
              opponentData.score = opponentScore + totalCardsValue;
              currentPlayer = gameData.opponentId;
            } else if(gameData.currentPlayer === gameData.opponentId) {
              //current player is opponentData, so we flip and use playerData
              playerData.score = playerScore + totalCardsValue;
              currentPlayer = gameData.playerId;
            }
          }
        }

        //update database, but set currentPlayer and sessionTimer first
        //reset timer
        const sessionTimer = (process.env.PLAYER_SESSION_DURATION_IN_MIN * 60) + getCurrentTimestamp();
        
        //remove card from user
        if(gameData.currentPlayer === gameData.playerId) {
          const availableCards = playerData.availableCards.filter((card) => {
            return (card !== selectedCard);
          })
          playerData.availableCards = availableCards;
        } else if(gameData.currentPlayer === gameData.opponentId) {
          const availableCards = opponentData.availableCards.filter((card) => {
            return (card !== selectedCard);
          })
          opponentData.availableCards = availableCards;
        }

        //ramba process
        const boardAvailableCards = JSON.parse(gameData.boardData).availableCards;
        let newBoardAvailableCards = null;
        if(boardAvailableCards && boardAvailableCards.length >= 2) {
          playerData.availableCards.push(boardAvailableCards[boardAvailableCards.length - 1]);
          opponentData.availableCards.push(boardAvailableCards[boardAvailableCards.length - 2]);

          //remove those last 2 cards
          newBoardAvailableCards = boardAvailableCards.slice(0, boardAvailableCards.length - 2);
        }

        if(currentPlayer) {
          //update database
          //handle playedCards show
          const playedCardsShow = JSON.parse(gameData.boardData).playedCardsShow;
          playedCardsShow.push(selectedCard);

          const boardData = {
            ...JSON.parse(gameData.boardData),
            playedCards: [], //reset playedCards
            playedCardsShow,
            availableCards: newBoardAvailableCards,
          }
          
          await database.execute(
            "UPDATE games SET boardData = ?, currentPlayer = ?, sessionTimer = ?, playerData = ?, opponentData = ? WHERE id = ?",
            [JSON.stringify(boardData), currentPlayer, sessionTimer, JSON.stringify(playerData), JSON.stringify(opponentData),  gameData.id]
          ).then(() => {
            resolve(true);
          }).catch((error) => {
            reject("Server error #1018");
          }) 
        } else {
          reject("Unkown server error #102");
        }

      } else {
        reject("Unknown error, #101");
      }

    })
  }

  static initialize = (params) => {
    return new Promise(async (resolve, reject) => {
      let {
        gameData,
        database
      } = params;

      //prepare cards
      const allAvailableCards = [ 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36];

      //changa
      this.shufflesCards(allAvailableCards);

      //pick mchezo
      const mchezo = allAvailableCards[0];

      //distribute to players
      const playerAvailableCards = allAvailableCards.splice(0, 6);
      const opponentAvailableCards = allAvailableCards.splice(0, 6);

      //prepare data
      const currentPlayer = gameData.playerId;
      const boardData = {
        availableCards: allAvailableCards,
        mchezo,
        playedCards:[],
        playedCardsShow: [],
      };
      const playerData = {
        availableCards: playerAvailableCards,
        score: 0,
      };
      const opponentData = {
        availableCards: opponentAvailableCards,
        score: 0,
      };

      database.execute(
        "UPDATE games SET boardData = ?, currentPlayer = ?, playerData = ?, opponentData = ? WHERE ( id = ?)",
        [ JSON.stringify(boardData), currentPlayer, JSON.stringify(playerData), JSON.stringify(opponentData), gameData.id ]
      ).then(() => {
        resolve(true);
      }).catch((error) => {
        reject("Database server error");
      })

    })
  }
}